// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.search {
  padding-left: 10px !important;
}

.pagination {
  margin-left: -244px;
}

:host ::ng-deep li[_ngcontent-vbg-c13] {
  font-size: 15px !important;
  vertical-align: top;
}

.nav-links {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.programEnroll {
  display: inline-block;
  width: 315px;
  font-size: 16px;
}

.abm-change-link {
  font-size: 14px;
}

.tileHeader {
  font: 18px "Omnes-ATT-W02-Medium";
  margin-bottom: 28px;
  margin-top: 11px;
}

.tileProgram {
  font-size: 16px;
}

.multi-table {
  line-height: 23px;
  /* height: 101px; */
  margin-left: 39px !important;
}

.multi-prog2 {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-left: 32px;
  border-right: 1px solid #d2d2d2;
  padding-right: 20px;
  min-width: 250px;
  flex: 1;
}
.multi-prog2:last-of-type {
  border-right: none;
}
@media (max-width: 1024px) {
  .multi-prog2 {
    margin-left: 19px;
    margin-bottom: 10px;
    border-right: none;
  }
}

.link-figure {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 40px;
  margin-inline-end: 40px;
}

.link-text {
  font-size: 16px;
}

.programs-row-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 1025px) and (min-width: 300px) {
  .programs-row-container {
    flex-direction: column;
  }
}
.programs-row-container .tileProgram > div:first-child,
.programs-row-container .program-label {
  min-height: 50px;
}

.remove-acct {
  margin-top: auto;
  padding-top: 20px;
}
@media (max-width: 1024px) {
  .remove-acct {
    padding-bottom: 17px;
    margin-right: 25px;
    border-bottom: 1px solid #d2d2d2;
    margin-top: 29px;
  }
}

.disable-url {
  pointer-events: none !important;
  color: #707070;
}

.flex-container-multiple-program {
  border-right: 1px solid #d2d2d2;
  display: flex;
  float: none;
  min-width: 250px;
  flex: 1;
  flex-direction: column;
  margin-left: 20px;
  padding-right: 20px;
}
@media screen and (max-width: 1025px) and (min-width: 300px) {
  .flex-container-multiple-program {
    border-right: 0;
    flex-direction: column;
    float: none;
    width: 100%;
  }
}

.panel-header {
  border-radius: 8px;
  border: 1px solid #d2d2d2;
  margin-bottom: 15px;
}

.panel {
  min-height: 280px;
  padding: 20px 0;
  position: relative;
}

@media (max-width: 1024px) {
  .panel-padding {
    padding: 0px !important;
  }
}
.link-button {
  padding-top: 10px !important;
}

.device-inventory-page {
  margin-bottom: 60px;
}

:host ::ng-deep div[_ngcontent-yww-c13] {
  font-size: 14px;
}

.radioStack {
  display: grid;
}

.radio {
  cursor: default;
  margin-bottom: 8px !important;
}

.fieldset-extended {
  margin: -10px 0px 0px 0px !important;
  border: none;
}

.error-alert {
  margin: 0 20%;
  margin-top: 30px;
}
.error-alert .reload {
  cursor: pointer;
}

.device-inventory1 {
  margin-top: 80px;
}

.mediaStop {
  height: 140px;
  width: 251px;
  margin-bottom: 20px;
}

.heading1 {
  margin: 32px 0;
  font-size: 40px !important;
  font-family: "Omnes-ATT-W02-Light";
}

.heading2 {
  font-size: 28px !important;
}

h1 {
  margin: 30px 0;
}

h1 {
  font-size: 20px;
  margin-bottom: 30px;
  margin-top: 20px;
}

h2 {
  font: 18px "Omnes-ATT-W02-Medium";
  margin-bottom: 20px;
}

hr {
  border: 1px solid #D1D2D3 !important;
  opacity: 1 !important;
}

.inventory-label {
  font-family: "Omnes-ATT-W02-Medium";
  font-size: 16px;
}

.program-label {
  font-family: "Omnes-ATT-W02";
  font-size: 16px;
}

.device-inventory {
  margin: 0 12.66%;
}
.device-inventory .hr-line {
  display: none;
}
.device-inventory .alert {
  margin-top: 28px;
}
.device-inventory .cancel-participation {
  padding-bottom: 15px;
}
.device-inventory .download-terms {
  display: inline;
  padding-left: 10px;
}
.device-inventory .icon-alert {
  color: #ffb81c !important;
  margin: 0;
}
.device-inventory .h1-content {
  font-size: 45px;
  margin-bottom: 1px;
  margin-top: 0px;
}
.device-inventory .h2-content {
  font-size: 30px;
  margin-bottom: -17px;
  margin-top: 10px;
}
.device-inventory .enrollDateInfoold {
  padding: 0;
  margin: 0;
  padding: 20px 0px 0px 20px;
}
.device-inventory .enrollDateInfoold a {
  padding: 0;
}
.device-inventory .enrollDateInfoold .alert-icon-ibm {
  width: 20px;
  float: left;
  margin-right: 10px;
}
.device-inventory .enrollDateInfoold .extra-content-ibm {
  float: left;
  width: 88%;
}
.device-inventory .enrollDateInfoold .icon-alert {
  width: 20px;
  height: 20px;
}
.device-inventory .enrollDateInfo {
  padding: 0;
  margin: 0;
  padding: 20px;
}
.device-inventory .enrollDateInfo a {
  padding: 0;
}
.device-inventory .enrollDateInfo .alert-icon-ibm {
  width: 20px;
  float: left;
  margin-right: 10px;
}
.device-inventory .enrollDateInfo .extra-content-ibm {
  float: left;
  width: 88%;
}
.device-inventory .enrollDateInfo .icon-alert {
  width: 20px;
  height: 20px;
}
.device-inventory .legend-container {
  width: 30%;
}
.device-inventory .panel-container {
  margin-top: 30px;
  position: relative;
  min-height: 174px;
  margin-bottom: 30px;
}
.device-inventory .form-group,
.device-inventory .form-group ~ p {
  margin-bottom: 0px;
}
.device-inventory .participation {
  margin-bottom: 10px;
}
.device-inventory .existParticipation {
  margin-bottom: 20px;
}
.device-inventory .nav-container-block {
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  border-left: 1px solid #d2d2d2;
  display: inline-block;
  left: 33%;
  margin-top: 20px;
  padding-left: 2px;
  position: absolute;
  top: 60%;
  width: 75%;
}
.device-inventory .pull-left {
  float: left;
  height: 100px;
}
@media only screen and (max-width: 430px) {
  .device-inventory .smallMobile {
    margin-right: 15px;
  }
}
.device-inventory .greybox {
  background: linear-gradient(#F1F2F3, #F1F2F3);
  margin-right: auto;
  margin-left: auto;
  height: auto;
  margin-bottom: 20px;
}
.device-inventory .container-box-sm {
  padding: 27px 20px 25px 44px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  max-width: 1250px;
}
.device-inventory .container-box-sm .input-field {
  width: 260px;
  height: 36px;
}
.device-inventory .container-box-sm .dropDownInput {
  width: 260px;
  height: 36px;
}
.device-inventory .container-box-sm .search-btn {
  width: 260px;
  height: 42px;
  margin-top: 15px;
  margin-left: 3px;
}
.device-inventory .container-box-sm .input-row {
  height: 70px;
}
.device-inventory .seachbox-heading {
  text-align: left;
  font-family: "ATT Aleck Sans";
  letter-spacing: 0.67px;
  color: #191919;
  opacity: 1;
  height: 36px;
  font-size: 24px;
  font-weight: bold;
}
.device-inventory .clear-btn {
  height: 21px;
  text-align: right;
  padding-top: 1px;
  font: 16px ATT Aleck Sans !important;
  margin-right: 30px;
  letter-spacing: 0.44px;
  color: #0568AE !important;
  opacity: 1;
}
.device-inventory .clear-btn a {
  color: #0568ae;
  text-decoration: underline;
  font-weight: normal;
}
.device-inventory .inputContent {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
.device-inventory .wireless-col {
  width: 160px;
}
.device-inventory .wireless-col-grp {
  width: 113px;
}
@media only screen and (max-width: 540px) {
  .device-inventory .wireless-align {
    width: 70% !important;
  }
  .device-inventory .wireless-col {
    width: 100% !important;
    float: left !important;
  }
  .device-inventory .wireless-col-grp {
    width: 100% !important;
  }
  .device-inventory .custumgrid-field {
    float: left !important;
    padding-left: 7px;
  }
  .device-inventory .hiddenswitch div:nth-child(2) {
    float: left !important;
  }
  .device-inventory .status-cols {
    width: 100% !important;
  }
}
.device-inventory [class^=col-] {
  padding: 0px 0px !important;
}
.device-inventory .table {
  margin-left: -10px;
}
.device-inventory .table tr, .device-inventory .table th, .device-inventory .table td {
  border: 0;
}
.device-inventory .tableoem tr td {
  padding-top: 5px !important;
}
.device-inventory .btn {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border: 1px solid transparent;
  color: white;
  cursor: pointer;
  display: inline-block;
  font: 1.9rem "Omnes-ATT-W02-Medium";
  padding: 9px 19px 10px 19px;
  text-align: center;
}
.device-inventory .btn:focus {
  outline: 1px dotted white;
  outline-offset: -5px;
}
.device-inventory .tooltip {
  position: sticky;
  display: inline-block;
}
.device-inventory .tooltip .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #f8f8f8;
  color: black;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  /* Position the tooltip */
  position: absolute;
  top: 195%;
  left: 50%;
  margin-left: -60px;
  border: 1px solid transparent;
  border-bottom-color: #a8a7a7;
  border-top-color: #a8a7a7;
  border-left-color: #a8a7a7;
  border-right-color: #a8a7a7;
}
.device-inventory .tooltip:hover .tooltiptext {
  visibility: visible;
}
.device-inventory i.tooltip-icon {
  position: sticky;
}
.device-inventory .btn-report {
  background: linear-gradient(to bottom, #087ac2 0%, #0568ae 100%);
  font-size: 17px;
  height: 35px;
  margin-left: 0px;
  transform: translateY(42px);
}
@media only screen and (max-width: 1200px) and (min-width: 920px) {
  .device-inventory .btn-report {
    width: 430px;
    margin-left: -37px;
  }
}
.device-inventory .navs-container {
  transform: translateY(-50%);
  border-left: 0px solid #d1d1d1;
  display: inline-block;
  left: 2%;
  padding-left: 2px;
  position: absolute;
  top: 69%;
  width: 100%;
}
.device-inventory .report-button {
  margin-top: 0px;
  width: 266px;
  height: 42px;
  background: #1483D9 0% 0% no-repeat padding-box;
  border: 1px solid #1A84D8;
  border-radius: 6px;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #FFFFFF;
  margin-right: 70px;
}
.device-inventory .cancel-participation,
.device-inventory .download-terms {
  float: left;
}
.device-inventory .navLinks {
  float: right;
  margin-top: 50px;
}
.device-inventory .oem-sms {
  width: 156px;
}
.device-inventory .oem-sms img {
  top: 934px;
  left: 350px;
  width: 49px;
  height: 52px;
}
.device-inventory .nav-icon li {
  display: inline-block;
  padding: 0 20px;
  text-align: center;
  vertical-align: top;
}
.device-inventory .nav-icon li figure {
  margin: 10px 0;
}
.device-inventory .nav-icon li i {
  font-size: 16px;
}
.device-inventory .nav-icon li img {
  top: 934px;
  left: 350px;
  width: 49px;
  height: 52px;
}
.device-inventory .nav-icon li a {
  margin-left: 10px;
}
.device-inventory .sub-headerold {
  margin-top: 30px;
  margin-bottom: 92px;
}
.device-inventory .sub-header,
.device-inventory .paginatio1n,
.device-inventory .toggle-header,
.device-inventory h1 {
  margin-top: 30px;
  margin-bottom: 7px;
}
.device-inventory .legend-data {
  margin-top: 20px;
}
.device-inventory .ctn-number {
  cursor: pointer;
  color: hsl(204.9, 94.4%, 35.1%);
  margin: 10px 0;
  line-height: 20px;
}
.device-inventory .ctn-imei {
  margin: 10px 0;
  line-height: 20px;
}
.device-inventory .imei1 {
  margin: 0 0 10px 0;
}
.device-inventory .imei2 {
  margin-bottom: 10px !important;
  margin-top: 4px !important;
}
.device-inventory .gridText {
  display: inline-flex;
}
.device-inventory .custumgrid-field {
  margin: 0 0 10px 0;
  display: inline-block;
  vertical-align: middle;
}
.device-inventory .custumgrid-field-status {
  vertical-align: super;
  line-height: 16px;
}
.device-inventory .profile {
  font-size: 18px !important;
}
.device-inventory .accordion {
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 60px;
}
.device-inventory .accheader {
  font-family: "Omnes-ATT-W02";
}
.device-inventory .color-square {
  border-radius: 2px;
  display: inline-block;
  height: 14px;
  margin-right: 10px;
  vertical-align: middle;
  width: 14px;
}
.device-inventory .username {
  margin-bottom: 10px !important;
  margin-top: 10px !important;
}
.device-inventory table tr td {
  padding-top: 20px !important;
}
.device-inventory .enrolled-active {
  background-color: #1483D9;
}
.device-inventory .enrolled-not-active {
  background-color: #B9D5E8;
}
.device-inventory .not-enrolled {
  background-color: #e97400;
}
.device-inventory .out-of-compliance {
  background-color: #cccccc;
}
.device-inventory .claimed-samsung {
  background-color: #035527;
}
.device-inventory .claimed-android™ {
  background-color: #035527;
}
.device-inventory .claimed-android {
  background-color: #035527;
}
.device-inventory .claimed-apple {
  background-color: #035527;
}
.device-inventory .claim-pending-samsung {
  background-color: #6BA179;
}
.device-inventory .claim-pending-android™ {
  background-color: #6BA179;
}
.device-inventory .claim-pending-android {
  background-color: #6BA179;
}
.device-inventory .claim-pending-apple {
  background-color: #6BA179;
}
.device-inventory .claim-pending {
  background-color: #6BA179;
}
.device-inventory .unclaim-pending-samsung {
  background-color: #9B8E82;
}
.device-inventory .unclaim-pending-android™ {
  background-color: #9B8E82;
}
.device-inventory .unclaim-pending-android {
  background-color: #9B8E82;
}
.device-inventory .unclaim-pending-apple {
  background-color: #9B8E82;
}
.device-inventory .unclaim-pending {
  background-color: #9B8E82;
}
.device-inventory .not-claimed {
  background-color: #e57200;
}
.device-inventory .claim-initiated {
  background-color: #e97400;
}
.device-inventory .line {
  margin: 20px 0;
}
.device-inventory a {
  cursor: pointer;
}
.device-inventory .page-count p.col-md-4 {
  margin-bottom: 0;
  margin-top: 0px !important;
  margin-left: 15px !important;
  text-align: left;
  position: relative;
  float: none;
  left: 0;
  padding-top: -5px;
}
.device-inventory .sub-headerold {
  margin-top: 30px;
  margin-bottom: 142px;
}
.device-inventory .greybox-text {
  height: 115px;
}
.device-inventory .search {
  position: absolute;
  width: 440px !important;
  transform: translateY(-128px);
  margin-left: 28px;
}
.device-inventory .flex-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: stretch;
  align-items: center;
}
.device-inventory .search-placeholder {
  min-height: 100px;
  width: 364px;
  flex: 1 0 auto;
  align-self: stretch;
}
.device-inventory .generate-inventory-report-button {
  min-width: 235px;
  flex: 1 0 auto;
  align-self: center;
  margin-top: 65px;
  transform: translateY(-90px);
}
@media (max-width: 1024px) {
  .device-inventory {
    margin: 0 15px;
    margin-top: 70px;
  }
  .device-inventory .nav-links {
    display: inline-flex;
    flex-direction: column;
  }
  .device-inventory .flex-container-multiple-program {
    flex-direction: column;
    flex-direction: column;
    flex-direction: column;
    flex-direction: column;
    flex-direction: column;
    border-right: 0;
    flex-direction: column;
    float: none;
    width: 100%;
  }
  .device-inventory .fieldset-extended {
    margin: -135px 0px 0px 5px !important;
    border: none;
  }
  .device-inventory .search {
    position: absolute;
    max-width: 275px;
    transform: translateY(-117px);
    margin-left: 20px;
    padding-left: 10px;
  }
  .device-inventory .btn-report {
    background: linear-gradient(to bottom, #087ac2 0%, #0568ae 100%);
    font-size: 17px;
    height: 35px;
    margin-left: -65px;
    margin-bottom: 15px;
    padding-right: 21px;
    padding-left: 18px;
    width: 263px;
    transform: translateY(110px);
  }
  .device-inventory .search-placeholder {
    min-height: 42px;
  }
  .device-inventory .generate-inventory-report-button {
    min-width: 235px;
    margin: -10px 0px 20px 0px;
  }
  .device-inventory .navLinks {
    float: left;
    margin-left: 66px;
    margin-top: 0px;
  }
  .device-inventory .oem-sms img {
    top: 934px;
    left: 350px;
    width: 49px;
    height: 52px;
  }
  .device-inventory [class^=col-md] {
    width: 100%;
  }
  .device-inventory .new-content-ibm {
    margin-right: 7px;
  }
  .device-inventory .report-button {
    margin-right: 15px !important;
    width: 280px;
    margin-top: 55px;
  }
  .device-inventory .enrollDateInfo {
    padding: 0;
    margin: 0;
    padding: 15px;
  }
  .device-inventory .greybox {
    height: 490px;
  }
  .device-inventory .dropDownInput {
    height: 80px !important;
  }
  .device-inventory .statusDropdown {
    margin-top: -20px !important;
  }
  .device-inventory .search-btn {
    margin-left: 0px !important;
  }
  .device-inventory .accordion {
    margin-bottom: 30px;
  }
  .device-inventory a {
    cursor: pointer;
  }
  .device-inventory h1 {
    margin: 20px 0 20px;
  }
  .device-inventory #totalCount {
    margin-top: 20px !important;
    margin-left: 15px !important;
  }
  .device-inventory .page-count p.col-sm-12 {
    margin-bottom: 0;
    text-align: left;
    float: left;
  }
  .device-inventory .error-alert {
    margin-top: 20px;
  }
  .device-inventory .hr-line {
    display: none;
  }
  .device-inventory .alert {
    margin-top: -60px;
  }
  .device-inventory .alert div:nth-child(2) {
    padding-right: 30px;
  }
  .device-inventory .cancel-participation {
    border-right: 0 solid #d2d2d2;
    display: block;
  }
  .device-inventory .download-terms {
    padding-left: 0;
  }
  .device-inventory .nav-container-block {
    transform: translateY(0%);
    transform: translateY(0%);
    transform: translateY(0%);
    transform: translateY(0%);
    transform: translateY(0%);
    border: 0;
    left: 0;
    position: relative;
    text-align: center;
    top: 13px;
    width: 100%;
    margin-bottom: 15px;
  }
  .device-inventory .paginat1ion,
  .device-inventory .toggle-header,
  .device-inventory .panel-container {
    margin-top: 20px;
  }
  .device-inventory .panel-container {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .device-inventory .legend-container {
    width: 100%;
  }
  .device-inventory .form-group,
  .device-inventory .form-group ~ p,
  .device-inventory .participation {
    margin-bottom: 20px;
  }
  .device-inventory .sub-header {
    margin: 20px 0 5px 0;
  }
  .device-inventory .report-button {
    margin-right: 15px !important;
    width: 280px;
    margin-top: 55px;
  }
  .device-inventory .nav-icon {
    margin: 0;
  }
  .device-inventory .nav-icon li:nth-child(1) {
    width: 50%;
  }
  .device-inventory .nav-icon li:nth-child(2) {
    width: 48%;
  }
  .device-inventory .nav-icon li:nth-child(3) {
    float: left;
    width: 50%;
  }
  .device-inventory .cancel-participation,
  .device-inventory .download-terms {
    float: none;
  }
  .device-inventory .radio {
    margin-bottom: 6px;
  }
}

.lic-contest {
  background-color: #cccccc;
  padding: 50px 0;
}
@media (max-width: 1024px) {
  .lic-contest abbr,
  .lic-contest label {
    display: block;
    margin: 0;
  }
}
.lic-contest .lic-container > div {
  margin-bottom: 10px;
}

.search-label {
  display: none;
}

.model-box p {
  font-weight: normal;
  margin-top: 10px;
}
.model-box ol {
  margin: 12px 0 10px 20px;
}
.model-box ol li {
  list-style: decimal;
  line-height: 20px;
  margin-top: 12px;
  padding-left: 15px;
  position: relative;
  text-align: left;
}
.model-box ul {
  margin: 12px 0 10px 20px;
}
.model-box .tab-content {
  left: 0;
  padding: 0 15px;
}
.model-box .startdate ul li {
  list-style-type: disc;
  margin-left: 15px;
}
.model-box .enrollPopup ul, .model-box .enrollPopup li {
  list-style: disc outside none;
  margin-left: 15px;
}

.oem-accesories {
  width: 150px;
}
.oem-accesories img {
  top: 934px;
  left: 350px;
  width: 36px;
  height: 52px;
}

.oem-accesories img {
  top: 934px;
  left: 350px;
  width: 50px;
  height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/manage-inventory/device-inventory/device-inventory.component.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACwBZ;EA4BA;IACE,YClDE;EFCN;ECgDE;IACE,aClDE;EFIN;EC6CE;IACE,UClDE;EFON;EC0CE;IACE,aClDE;EFUN;ECuCE;IACE,aClDE;EFaN;ECoCE;IACE,UClDE;EFgBN;ECiCE;IACE,aClDE;EFmBN;EC8BE;IACE,aClDE;EFsBN;EC2BE;IACE,UClDE;EFyBN;ECwBE;IACE,aClDE;EF4BN;ECqBE;IACE,aClDE;EF+BN;ECkBE;IACE,WClDE;EFkCN;ECoBE;IACE,kBCvDE;EFqCN;ECiBE;IACE,mBCvDE;EFwCN;ECcE;IACE,gBCvDE;EF2CN;ECWE;IACE,mBCvDE;EF8CN;ECQE;IACE,mBCvDE;EFiDN;ECKE;IACE,gBCvDE;EFoDN;ECEE;IACE,mBCvDE;EFuDN;ECDE;IACE,mBCvDE;EF0DN;ECJE;IACE,gBCvDE;EF6DN;ECPE;IACE,mBCvDE;EFgEN;ECVE;IACE,mBCvDE;EFmEN;ECbE;IACE,iBCvDE;EFsEN;AACF;AC9CI;EAoCA;IACE,YC9DE;EF2EN;ECdE;IACE,aC9DE;EF8EN;ECjBE;IACE,UC9DE;EFiFN;ECpBE;IACE,aC9DE;EFoFN;ECvBE;IACE,aC9DE;EFuFN;EC1BE;IACE,UC9DE;EF0FN;EC7BE;IACE,aC9DE;EF6FN;EChCE;IACE,aC9DE;EFgGN;ECnCE;IACE,UC9DE;EFmGN;ECtCE;IACE,aC9DE;EFsGN;ECzCE;IACE,aC9DE;EFyGN;EC5CE;IACE,WC9DE;EF4GN;EC1CE;IACE,kBCnEE;EF+GN;EC7CE;IACE,mBCnEE;EFkHN;EChDE;IACE,gBCnEE;EFqHN;ECnDE;IACE,mBCnEE;EFwHN;ECtDE;IACE,mBCnEE;EF2HN;ECzDE;IACE,gBCnEE;EF8HN;EC5DE;IACE,mBCnEE;EFiIN;EC/DE;IACE,mBCnEE;EFoIN;EClEE;IACE,gBCnEE;EFuIN;ECrEE;IACE,mBCnEE;EF0IN;ECxEE;IACE,mBCnEE;EF6IN;EC3EE;IACE,iBCnEE;EFgJN;AACF;AAlJA;EAAU,6BAAA;AAqJV;;AApJC;EAAc,mBAAA;AAwJf;;AAvJC;EACC,0BAAA;EACA,mBAAA;AA0JF;;AAvJA;EAGE,aAAA;EACA,mBAAA;EACA,6BAAA;AAwJF;;AArJA;EACE,qBAAA;EACA,YAAA;EACA,eAAA;AAwJF;;AArJA;EACE,eAAA;AAwJF;;AAlJA;EACE,iCAAA;EACA,mBAAA;EACA,gBAAA;AAqJF;;AAjJA;EACE,eAAA;AAoJF;;AAlJA;EACE,iBAAA;EACA,mBAAA;EACA,4BAAA;AAqJF;;AAlJA;EACK,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,OAAA;AAqJL;AApJK;EACE,kBAAA;AAsJP;ACvLI;EDsBJ;IAcM,iBAAA;IACA,mBAAA;IACA,kBAAA;EAuJJ;AACF;;AApJA;EAMI,cAAA;EACA,uBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;AAkJJ;;AA/IA;EACE,eAAA;AAkJF;;AA/IA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAkJF;AAjJE;EAJF;IAKI,sBAAA;EAoJF;AACF;AAlJE;;EAEE,gBAAA;AAoJJ;;AAhJA;EACE,gBAAA;EACA,iBAAA;AAmJF;AC9NI;EDyEJ;IAIQ,oBAAA;IACA,kBAAA;IACA,gCAAA;IACA,gBAAA;EAqJN;AACF;;AAlJA;EACE,+BAAA;EACA,cAAA;AAqJF;;AAlJA;EACE,+BAAA;EAEA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,OAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AAqJF;AApJE;EAVF;IAWI,eAAA;IACA,sBAAA;IACA,WAAA;IACA,WAAA;EAuJF;AACF;;AApJA;EACI,kBAAA;EACA,yBAAA;EACA,mBAAA;AAuJJ;;AApJA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AAuJF;;AApJA;EACA;IACE,uBAAA;EAuJA;AACF;AApJA;EACE,4BAAA;AAsJF;;AAlJA;EACE,mBAAA;AAqJF;;AAlJA;EACE,eAAA;AAqJF;;AAlJA;EACE,aAAA;AAqJF;;AAlJA;EACE,eAAA;EACA,6BAAA;AAqJF;;AAxIA;EACE,oCAAA;EACA,YAAA;AA2IF;;AApIA;EACC,aAAA;EACA,gBAAA;AAuID;AArIC;EACE,eAAA;AAuIH;;AAlIA;EACE,gBAAA;AAqIF;;AAjIA;EACC,aAAA;EACA,YAAA;EACA,mBAAA;AAoID;;AAjIC;EACC,cAAA;EACA,0BAAA;EACA,kCAAA;AAoIF;;AAjIC;EACE,0BAAA;AAoIH;;AAjIA;EACC,cAAA;AAoID;;AAlIA;EACM,eAAA;EACA,mBAAA;EACA,gBAAA;AAqIN;;AAlII;EACE,iCAAA;EACA,mBAAA;AAqIN;;AAjIA;EAEE,oCAAA;EACA,qBAAA;AAmIF;;AAjIA;EACC,mCAAA;EACA,eAAA;AAoID;;AAjIA;EACE,4BAAA;EACA,eAAA;AAoIF;;AAlIA;EACC,gBAAA;AAqID;AAnIC;EACE,aAAA;AAqIH;AAlIC;EAEC,gBAAA;AAmIF;AAhIC;EAEE,oBAAA;AAiIH;AA9HC;EACE,eAAA;EACA,kBAAA;AAgIH;AA7HC;EACE,yBAAA;EACA,SAAA;AA+HH;AA7HC;EACC,eAAA;EACA,kBAAA;EACA,eAAA;AA+HF;AA7HC;EACC,eAAA;EACA,oBAAA;EACA,gBAAA;AA+HF;AA7HC;EACC,UAAA;EACA,SAAA;EACA,0BAAA;AA+HF;AA7HE;EACE,UAAA;AA+HJ;AA5HE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AA8HJ;AA3HE;EACE,WAAA;EACA,UAAA;AA6HJ;AA1HE;EACE,WAAA;EACA,YAAA;AA4HJ;AAxHC;EACE,UAAA;EACA,SAAA;EACA,aAAA;AA0HH;AAxHG;EACE,UAAA;AA0HL;AAvHG;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AAyHL;AAtHG;EACE,WAAA;EACA,UAAA;AAwHL;AArHG;EACE,WAAA;EACA,YAAA;AAuHL;AAnHC;EACE,UAAA;AAqHH;AAlHC;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAoHH;AAjHC;;EAEE,kBAAA;AAmHH;AA5GC;EACE,mBAAA;AA8GH;AA3GC;EACC,mBAAA;AA6GF;AA1GC;EC1UG,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;ED4UD,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAgHH;AA9GC;EACC,WAAA;EACA,aAAA;AAgHF;AA9GA;EACE;IACE,kBAAA;EAgHF;AACF;AA7GA;EAEE,6CAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AA8GF;AA3GA;EACE,4BAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AA6GF;AA3GE;EACE,YAAA;EACA,YAAA;AA6GJ;AA3GE;EACE,YAAA;EACA,YAAA;AA6GJ;AA3GE;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AA6GJ;AA3GE;EACE,YAAA;AA6GJ;AAzGA;EACE,gBAAA;EACA,6BAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AA2GF;AAxGA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,UAAA;AA0GF;AAxGA;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;AA0GF;AAxGA;EACE,8BAAA;EACA,mBAAA;EACA,kBAAA;AA0GF;AAvGA;EACE,YAAA;AAyGF;AAtGA;EACE,YAAA;AAwGF;AApGA;EACE;IACI,qBAAA;EAsGJ;EAnGA;IACE,sBAAA;IACA,sBAAA;EAqGF;EAlGA;IACE,sBAAA;EAoGF;EAjGA;IACE,sBAAA;IACA,iBAAA;EAmGF;EAhGA;IACE,sBAAA;EAkGF;EA/FA;IACE,sBAAA;EAiGF;AACF;AA7FA;EACE,2BAAA;AA+FF;AA5FA;EACE,kBAAA;AA8FF;AA7FE;EACE,SAAA;AA+FJ;AA3FE;EACE,2BAAA;AA6FJ;AAzFA;ECxdI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;ED0dF,6BAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,kBAAA;AA+FF;AA7FE;EACE,yBAAA;EACA,oBAAA;AA+FJ;AA3FA;EACE,gBAAA;EACA,qBAAA;AA6FF;AA1FA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AA4FF;AAxFA;EACE,mBAAA;AA0FF;AAvFA;EACE,gBAAA;AAyFF;AAtFA;EAEI,gEAAA;EACA,eAAA;EACA,YAAA;EAEA,gBAAA;EACA,2BAAA;AAsFJ;AApFI;EATJ;IAWO,YAAA;IACF,kBAAA;EAsFH;AACF;AAlFC;EACE,2BAAA;EACA,8BAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAoFH;AAlFA;EACE,eAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EAEA,kBAAA;AAmFF;AAjFC;;EAEE,WAAA;AAmFH;AAjFC;EACC,YAAA;EACA,gBAAA;AAmFF;AAjFC;EACC,YAAA;AAmFF;AAjFE;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAmFJ;AA9EG;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAgFL;AA7EK;EACE,cAAA;AA+EP;AA5EK;EACE,eAAA;AA8EP;AA3EK;EACC,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AA6EN;AA1EK;EACE,iBAAA;AA4EP;AAxEC;EACC,gBAAA;EACA,mBAAA;AA0EF;AAvEC;;;;EAIE,gBAAA;EACA,kBAAA;AAyEH;AAvEC;EACE,gBAAA;AAyEH;AAtEC;EACE,eAAA;EAEA,+BAAA;EACA,cAAA;EACA,iBAAA;AAuEH;AApEC;EACC,cAAA;EACC,iBAAA;AAsEH;AAjEC;EACC,kBAAA;AAmEF;AAhEA;EACE,8BAAA;EACA,0BAAA;AAkEF;AA/DA;EACE,oBAAA;AAiEF;AA9DC;EACC,kBAAA;EACA,qBAAA;EACA,sBAAA;AAgEF;AA7DC;EAEC,qBAAA;EACA,iBAAA;AA8DF;AA3DC;EACE,0BAAA;AA6DH;AA3DC;EACE,gCAAA;EACA,mBAAA;AA6DH;AA3DC;EACE,4BAAA;AA6DH;AA3DC;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AA6DH;AA1DC;EACE,8BAAA;EACA,2BAAA;AA4DH;AAzDC;EACE,4BAAA;AA2DH;AAzDC;EAEE,yBAAA;AA0DH;AAvDC;EAEE,yBAAA;AAwDH;AArDC;EAEE,yBAAA;AAsDH;AAnDC;EACE,yBAAA;AAqDH;AAlDC;EAEE,yBAAA;AAmDH;AAhDC;EAEE,yBAAA;AAiDH;AA9CC;EAEE,yBAAA;AA+CH;AA5CC;EAEC,yBAAA;AA6CF;AAzCA;EACE,yBAAA;AA2CF;AAxCA;EACE,yBAAA;AA0CF;AAvCA;EACE,yBAAA;AAyCF;AAtCA;EACE,yBAAA;AAwCF;AArCA;EACE,yBAAA;AAuCF;AAnCA;EACE,yBAAA;AAqCF;AAlCA;EACE,yBAAA;AAoCF;AAjCA;EACE,yBAAA;AAmCF;AAhCA;EACE,yBAAA;AAkCF;AA/BA;EACE,yBAAA;AAiCF;AA7BC;EACE,yBAAA;AA+BH;AA5BC;EACE,yBAAA;AA8BH;AA3BC;EACE,cAAA;AA6BH;AA1BC;EACE,eAAA;AA4BH;AAxBK;EACE,gBAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,iBAAA;AA0BP;AAvBA;EACE,gBAAA;EACA,oBAAA;AAyBF;AAtBC;EACE,aAAA;AAwBH;AAtBC;EACC,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,iBAAA;AAwBF;AArBC;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAuBF;AArBA;EACE,iBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAuBF;AAnBA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EAIA,gBAAA;EACA,4BAAA;AAkBF;ACx2BI;EDkOJ;IAkpBG,cAAA;IACA,gBAAA;EARD;EAZA;IACE,oBAAA;IACA,sBAAA;EAcF;EAZA;ICz1BE,sBAAA;IAAA,sBAAA;IAAA,sBAAA;IAAA,sBAAA;IAAA,sBAAA;ID41BA,eAAA;IACA,sBAAA;IACA,WAAA;IACA,WAAA;EAiBF;EAbA;IACE,qCAAA;IACA,YAAA;EAeF;EAVC;IACG,kBAAA;IACA,gBAAA;IACA,6BAAA;IACA,iBAAA;IACA,kBAAA;EAYJ;EAVE;IAEI,gEAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;IACA,YAAA;IAEA,4BAAA;EAUN;EARE;IACE,gBAAA;EAUJ;EAPE;IACE,gBAAA;IAGA,0BAAA;EAOJ;EAJE;IACE,WAAA;IACA,iBAAA;IACA,eAAA;EAMJ;EAUI;IACE,UAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EARN;EAYE;IACE,WAAA;EAVJ;EAYG;IACA,iBAAA;EAVH;EAaC;IACC,6BAAA;IACA,YAAA;IACA,gBAAA;EAXF;EAaC;IACC,UAAA;IACA,SAAA;IACA,aAAA;EAXF;EAaC;IAEC,aAAA;EAZF;EAcC;IACC,uBAAA;EAZF;EAcA;IACE,4BAAA;EAZF;EAcA;IACE,2BAAA;EAZF;EAcC;IACE,mBAAA;EAZH;EAeC;IACE,eAAA;EAbH;EAeC;IACE,mBAAA;EAbH;EAgBC;IACE,2BAAA;IACA,4BAAA;EAdH;EAkBI;IACG,gBAAA;IAEA,gBAAA;IAEA,WAAA;EAlBP;EAsBC;IACE,gBAAA;EApBH;EAsBC;IACA,aAAA;EApBD;EAuBC;IACE,iBAAA;EArBH;EAwBK;IACE,mBAAA;EAtBP;EA2BC;IACE,6BAAA;IACA,cAAA;EAzBH;EA4BC;IACE,eAAA;EA1BH;EA6BC;ICt/BC,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IDw/BC,SAAA;IACA,OAAA;IACA,kBAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,mBAAA;EAvBH;EA0BC;;;IAGE,gBAAA;EAxBH;EA4BC;IACE,gBAAA;IACA,mBAAA;EA1BH;EA4BC;IACE,WAAA;EA1BH;EA6BC;;;IAGE,mBAAA;EA3BH;EA8BC;IACE,oBAAA;EA5BH;EA+BC;IACC,6BAAA;IACA,YAAA;IACA,gBAAA;EA7BF;EAiCC;IACE,SAAA;EA/BH;EAiCG;IACE,UAAA;EA/BL;EAkCG;IACE,UAAA;EAhCL;EAmCG;IACE,WAAA;IACA,UAAA;EAjCL;EAqCC;;IAEE,WAAA;EAnCH;EAsCC;IACC,kBAAA;EApCF;AACF;;AA0CA;EASC,yBAAA;EACA,eAAA;AA/CD;ACtiCI;ED6kCD;;IAEE,cAAA;IACA,SAAA;EApCH;AACF;AA0CC;EACE,mBAAA;AAxCH;;AA2CA;EACC,aAAA;AAxCD;;AA4CC;EACE,mBAAA;EACA,gBAAA;AAzCH;AA2CC;EACM,wBAAA;AAzCP;AA0CQ;EACL,mBAAA;EACC,iBAAA;EACW,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAxCf;AA2CC;EACU,wBAAA;AAzCX;AAmEC;EACG,OAAA;EACG,eAAA;AAjEP;AAsEK;EACE,qBAAA;EACA,iBAAA;AApEP;AAyEE;EACI,6BAAA;EACA,iBAAA;AAvEN;;AA6EA;EACE,YAAA;AA1EF;AA4EE;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AA1EJ;;AA6EA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AA1EF","sourcesContent":["\n@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n.search { padding-left: 10px !important;}\n .pagination { margin-left: -244px; }\n :host ::ng-deep  li[_ngcontent-vbg-c13] {\n  font-size: 15px !important;\n  vertical-align: top;\n}\n\n.nav-links{\n  // display: inline-flex;\n  // margin-left: 40px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n.programEnroll{\n  display: inline-block;\n  width: 315px;\n  font-size: 16px;\n}\n\n.abm-change-link{\n  font-size: 14px;\n  // @include respond-to (small) {\n  // margin-left: 52px;\n  // }\n}\n\n.tileHeader {\n  font: 18px 'Omnes-ATT-W02-Medium';\n  margin-bottom: 28px;\n  margin-top: 11px;\n\n}\n\n.tileProgram{\n  font-size: 16px;\n}\n.multi-table {\n  line-height: 23px;\n  /* height: 101px; */\n  margin-left: 39px !important;\n}\n\n.multi-prog2{\n     display: inline-flex;\n     flex-direction: column;\n     align-items: flex-start;\n     flex-wrap: wrap;\n     margin-left: 32px;\n     border-right: 1px solid #d2d2d2;\n     padding-right: 20px;\n     min-width: 250px;\n     flex: 1;\n     &:last-of-type {\n       border-right: none;\n     }\n     @include respond-to (small) {\n      margin-left: 19px;\n      margin-bottom: 10px;\n      border-right: none;\n     }\n}\n\n.link-figure {\n    // display: flex;\n    // flex-flow: column;\n    // /* width: 30vw; */\n    // align-items: center;\n    // width:156px;\n    display: block;\n    margin-block-start: 1em;\n    margin-block-end: 1em;\n    margin-inline-start: 40px;\n    margin-inline-end: 40px;\n}\n\n.link-text {\n  font-size: 16px;\n}\n\n.programs-row-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  @media screen and (max-width: 1025px) and (min-width: 300px) {\n    flex-direction: column;\n  }\n  \n  .tileProgram > div:first-child,\n  .program-label {\n    min-height: 50px;\n  }\n}\n\n.remove-acct{\n  margin-top: auto; \n  padding-top: 20px;\n    @include respond-to (small) {\n        padding-bottom: 17px;\n        margin-right: 25px;\n        border-bottom: 1px solid #d2d2d2;\n        margin-top: 29px;\n  }\n}\n\n.disable-url{\n  pointer-events: none !important;\n  color: #707070;\n}\n\n.flex-container-multiple-program {\n  border-right: 1px solid color(default, dark);\n  display: -webkit-flex;\n  display: flex;\n  float: none;\n  min-width: 250px;\n  flex: 1;\n  flex-direction: column;\n  margin-left: 20px;\n  padding-right: 20px;\n  @media screen and (max-width: 1025px) and (min-width: 300px)  {\n    border-right: 0;\n    flex-direction: column;\n    float: none;\n    width: 100%;\n  }\n}\n\n.panel-header {\n    border-radius: 8px;\n    border: 1px solid #d2d2d2;\n    margin-bottom: 15px;\n}\n\n.panel {\n  min-height: 280px;\n  padding: 20px 0;\n  position: relative;\n}\n\n@media (max-width: 1024px) {\n.panel-padding {\n  padding: 0px !important;\n}\n}\n\n.link-button {\n  padding-top: 10px !important;\n}\n\n\n.device-inventory-page {\n  margin-bottom: 60px;\n}\n\n:host ::ng-deep div[_ngcontent-yww-c13] {\n  font-size: 14px;\n}\n  \n.radioStack{\n  display:grid;\n}\n\n.radio{\n  cursor: default;\n  margin-bottom: 8px !important;\n}\n\n// .searchBox-label{\n//   padding-bottom: 10px;\n//   font: 1.6rem 'Omnes-ATT-W02-Medium';\n//   margin: -175px 0px 0px 20px;\n\n//   @media (max-width: 1024px) {\n//     margin: -120px 0px 0px 15px;\n//   }\n// }\n\n.fieldset-extended {\n  margin: -10px 0px 0px 0px !important;\n  border: none;\n}\n\n// .list-buttons{\n//   margin-top: -25px;\n// }\n\n.error-alert {\n margin: 0 20%;\n margin-top: 30px;\n \n .reload {\n   cursor:pointer;\n }\n\n}\n\n.device-inventory1 {\n  margin-top: 80px;\n}\n\n\n.mediaStop{\n height:140px;\n width:251px;\n margin-bottom: 20px;\n }\n\n .heading1 {\n  margin: 32px 0;\n  font-size: 40px !important;\n  font-family: \"Omnes-ATT-W02-Light\";\n }\n\n .heading2 {\n   font-size: 28px !important;\n }\n\nh1 {\n margin: 30px 0;\n} \nh1 {\n      font-size: 20px;\n      margin-bottom: 30px;\n      margin-top: 20px;\n    }\n\n    h2 {\n      font: 18px 'Omnes-ATT-W02-Medium';;\n      margin-bottom: 20px;\n    }\n\n\nhr{\n  //border: 1px solid #d2d2d2;\n  border: 1px solid #D1D2D3 !important;\n  opacity: 1 !important;\n}\n.inventory-label{\n font-family: 'Omnes-ATT-W02-Medium';\n font-size: 16px;\n}\n\n.program-label{\n  font-family: 'Omnes-ATT-W02';\n  font-size: 16px;\n }\n.device-inventory {\n margin: 0 12.66%;\n\n .hr-line {\n   display: none;\n }\n\n .alert {\n  //  margin-top: -60px;\n  margin-top:28px;\n }\n\n .cancel-participation {\n //  border-right: 1px solid color(default, dark);\n   padding-bottom: 15px;\n }\n\n .download-terms {\n   display: inline;\n   padding-left: 10px;\n }\n \n .icon-alert {\n   color: #ffb81c !important;\n   margin: 0;\n }\n .h1-content {\n  font-size: 45px;\n  margin-bottom: 1px;\n  margin-top: 0px;\n }\n .h2-content {\n  font-size: 30px;\n  margin-bottom: -17px;\n  margin-top: 10px;\n }\n .enrollDateInfoold{\n  padding: 0;\n  margin: 0;\n  padding: 20px 0px 0px 20px;\n\n  a {\n    padding: 0;\n  }\n\n  .alert-icon-ibm {\n    width: 20px;\n    float: left;\n    margin-right: 10px;\n  }\n\n  .extra-content-ibm {\n    float: left;\n    width: 88%;\n}\n\n  .icon-alert {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n .enrollDateInfo{\n   padding: 0;\n   margin: 0;\n   padding: 20px;\n\n   a {\n     padding: 0;\n   }\n\n   .alert-icon-ibm {\n     width: 20px;\n     float: left;\n     margin-right: 10px;\n   }\n\n   .extra-content-ibm {\n     float: left;\n     width: 88%;\n }\n\n   .icon-alert {\n     width: 20px;\n     height: 20px;\n   }\n }\n\n .legend-container {\n   width: 30%;\n }\n\n .panel-container {\n   margin-top: 30px;\n   position: relative;\n   min-height: 174px;\n   margin-bottom: 30px;\n }\n\n .form-group,\n .form-group ~ p {\n   margin-bottom: 0px;\n }\n\n // .acc-content {\n //   margin-bottom: 30px;\n // }\n\n .participation {\n   margin-bottom: 10px;\n }\n\n .existParticipation {\n  margin-bottom: 20px;\n}\n\n .nav-container-block {\n   @include vendor-prefix('transform', translateY(-50%));\n   border-left: 1px solid color(default, dark);\n   display: inline-block;\n   left: 33%;\n   margin-top: 20px;\n   padding-left: 2px;\n   position: absolute;\n   top: 60%;\n   width: 75%;\n }\n .pull-left {\n  float: left;\n  height: 100px;\n}\n@media only screen and (max-width: 430px){\n  .smallMobile{\n    margin-right: 15px;\n  }\n}\n\n.greybox{\n  //background: linear-gradient( rgba(216, 213, 213, 0.5), rgba(216, 213, 213, 0.5) );\n  background: linear-gradient( #F1F2F3,#F1F2F3 );\n  margin-right: auto;\n  margin-left:auto;\n  height: auto;\n  margin-bottom: 20px;\n}\n\n.container-box-sm {\n  padding: 27px 20px 25px 44px;\n  height: auto;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1250px;\n\n  .input-field{\n    width: 260px;\n    height: 36px;\n  }\n  .dropDownInput{\n    width: 260px;\n    height: 36px;\n  }\n  .search-btn{\n    width: 260px;\n    height: 42px;\n    margin-top: 15px;\n    margin-left: 3px;\n  }\n  .input-row{\n    height: 70px;\n  }\n}\n\n.seachbox-heading{\n  text-align: left;\n  font-family: 'ATT Aleck Sans';\n  letter-spacing: 0.67px;\n  color: #191919;\n  opacity: 1;\n  height: 36px;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.clear-btn{\n  height: 21px;\n  text-align: right;\n  padding-top: 1px;\n  font: 16px ATT Aleck Sans !important;\n  margin-right: 30px;\n  letter-spacing: 0.44px;\n  color: #0568AE !important;\n  opacity: 1;\n}\n.clear-btn a {\n  color: #0568ae;\n  text-decoration: underline;\n  font-weight: normal;\n}\n.inputContent {\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.wireless-col{\n  width: 160px;\n}\n\n.wireless-col-grp{\n  width: 113px;\n}\n\n\n@media only screen and (max-width: 540px){\n  .wireless-align{\n      width:70% !important;\n  }\n\n  .wireless-col{\n    width:100% !important;\n    float: left !important;\n  }\n\n  .wireless-col-grp{\n    width: 100% !important;\n  }\n\n  .custumgrid-field{\n    float: left !important;\n    padding-left: 7px;\n  }\n\n  .hiddenswitch div:nth-child(2){\n    float: left !important;\n  }\n\n  .status-cols{\n    width: 100% !important;\n  }\n\n}\n\n[class^='col-'] {\n  padding: 0px 0px !important;\n}\n\n.table {\n  margin-left: -10px;\n  tr,th,td {\n    border:0 ;\n  } \n}\n.tableoem{\n  tr td{\n    padding-top: 5px !important;\n  }\n\n}\n.btn {\n  @include vendor-prefix('border-radius', 8px);\n  border: 1px solid transparent;\n  color: color(default, light);\n  cursor: pointer;\n  display: inline-block;\n  font: 1.9rem 'Omnes-ATT-W02-Medium'; //TODO: change this to 1.7rem when changing fonts to Aleck\n  padding: 9px 19px 10px 19px;\n  text-align: center;\n\n  &:focus {\n    outline: 1px dotted color(default, light);\n    outline-offset: -5px;\n  }\n}\n\n.tooltip {\n  position: sticky;\n  display: inline-block;\n}\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 250px;\n  background-color: #f8f8f8;\n  color: black;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  /* Position the tooltip */\n  position: absolute;\n  top: 195%;\n  left: 50%;\n  margin-left: -60px;\n  border: 1px solid transparent;\n  border-bottom-color: #a8a7a7;\n  border-top-color: #a8a7a7;\n  border-left-color: #a8a7a7;\n  border-right-color: #a8a7a7;\n\n}\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n}\n\ni.tooltip-icon {\n  position: sticky;\n}\n\n.btn-report {\n    // background: linear-gradient(to bottom, #087ac2 0%, color(secondary,base) 100%);\n    background: linear-gradient(to bottom, #087ac2 0%, #0568ae 100%);\n    font-size: 17px;\n    height: 35px;\n    //width: 380px;\n    margin-left: 0px;\n    transform: translateY(42px);\n\n    @media only screen and\n   (max-width: 1200px) and (min-width:920px) {\n       width: 430px;\n     margin-left: -37px;\n      \n     }\n     \n}\n .navs-container {\n   transform: translateY(-50%);\n   border-left: 0px solid #d1d1d1;\n   display: inline-block;\n   left: 2%;\n   padding-left: 2px;\n   position: absolute;\n   top: 69%;\n   width: 100%;\n}\n.report-button{\n  margin-top:0px;\n  width: 266px;\n  height: 42px;\n  background: #1483D9 0% 0% no-repeat padding-box;\n  border: 1px solid #1A84D8;\n  border-radius: 6px;\n  opacity: 1;\n  text-align: center;\n  letter-spacing: 0px;\n  color: #FFFFFF;\n  //margin-left:233px;\n  margin-right: 70px;\n}\n .cancel-participation,\n .download-terms {\n   float: left;\n }\n .navLinks{\n  float: right;\n  margin-top: 50px;\n }\n .oem-sms {\n  width: 156px;\n  //margin-left: 40px;\n  img {\n    top: 934px;\n    left: 350px;\n    width: 49px;\n    height: 52px;\n  }\n}\n\n .nav-icon {\n   li {\n     display: inline-block;\n     padding: 0 20px;\n     text-align: center;\n     vertical-align: top;\n     //width: calc(33% - 1px);\n\n     figure {\n       margin: 10px 0;\n     }\n\n     i {\n       font-size: 16px;\n     }\n\n     img {\n      top: 934px;\n      left: 350px;\n      width: 49px;\n      height: 52px;\n     }\n\n     a {\n       margin-left: 10px;\n     }\n   }\n }\n .sub-headerold {\n  margin-top: 30px;\n  margin-bottom: 92px;\n }\n\n .sub-header,\n .paginatio1n,\n .toggle-header,\n h1 {\n   margin-top: 30px;\n   margin-bottom: 7px;\n }\n .legend-data{\n   margin-top: 20px;\n }\n\n .ctn-number {\n   cursor: pointer;\n //text-decoration: underline;\n   color: color(secondary, base);\n   margin: 10px 0;\n   line-height: 20px;\n }\n\n .ctn-imei {\n  margin: 10px 0;\n   line-height: 20px;\n\n }\n\n\n .imei1{\n  margin: 0 0 10px 0;\n}\n\n.imei2{\n  margin-bottom: 10px !important;\n  margin-top: 4px !important;\n}\n\n.gridText{\n  display:inline-flex\n}\n \n .custumgrid-field {\n  margin: 0 0 10px 0;\n  display: inline-block;\n  vertical-align: middle;\n }\n\n .custumgrid-field-status{\n  // margin: 0 0 11px 0;\n  vertical-align: super;\n  line-height: 16px;\n }\n\n .profile{\n   font-size: 18px !important;\n }\n .accordion {\n   border-bottom: 1px solid color(default, darker);\n   margin-bottom: 60px;\n }\n .accheader{\n   font-family: 'Omnes-ATT-W02';\n }\n .color-square {\n   border-radius: 2px;\n   display: inline-block;\n   height: 14px;\n   margin-right: 10px;\n   vertical-align: middle;\n   width: 14px;\n }\n\n .username{\n   margin-bottom: 10px !important;\n   margin-top: 10px !important;\n }\n \n table tr td{\n   padding-top: 20px !important;\n }\n .enrolled-active {\n   //background-color: color(enrolledActive);\n   background-color: #1483D9;\n }\n\n .enrolled-not-active {\n   //background-color: color(enrolledNotActive);\n   background-color: #B9D5E8;\n }\n\n .not-enrolled {\n   //background-color: color(notEnrolled);\n   background-color: #e97400;\n }\n\n .out-of-compliance {\n   background-color: color(outOfCompliance);\n }\n\n .claimed-samsung {\n  //  background-color: color(enrolledActive);\n   background-color: #035527;\n }\n \n .claimed-android™ {\n  //  background-color: color(enrolledActive);\n   background-color: #035527;\n }\n\n .claimed-android {\n  //  background-color: color(enrolledActive);\n   background-color: #035527;\n }\n \n .claimed-apple {\n  // background-color: color(enrolledActive);\n  background-color: #035527;\n\n}\n\n.claim-pending-samsung{\n  background-color: #6BA179;\n\n}\n.claim-pending-android™{\n  background-color: #6BA179;\n\n}\n.claim-pending-android{\n  background-color: #6BA179;\n\n}\n.claim-pending-apple{\n  background-color: #6BA179;\n\n}\n.claim-pending{\n  background-color: #6BA179;\n\n}\n\n.unclaim-pending-samsung{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending-android™{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending-android{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending-apple{\n  background-color: #9B8E82;\n\n}\n.unclaim-pending{\n  background-color: #9B8E82;\n\n}\n \n .not-claimed {\n   background-color: #e57200;\n }\n\n .claim-initiated {\n   background-color: #e97400;\n }\n\n .line {\n   margin: 20px 0;\n }\n\n a {\n   cursor: pointer;\n }\n .page-count{\n   //margin-bottom: 30px !important;\n     p.col-md-4 {\n       margin-bottom: 0;\n       margin-top: 0px !important;\n       margin-left: 15px !important;\n       text-align: left;\n       position: relative;\n       float: none;\n       left:0;\n       padding-top:-5px;\n     }\n}\n.sub-headerold {\n  margin-top: 30px;\n  margin-bottom: 142px;\n }\n\n .greybox-text {\n   height: 115px;\n }\n .search { \n  position: absolute;\n  width: 440px !important; \n  transform: translateY(-128px); \n  margin-left: 28px; \n  //padding-left: 10px !important;\n }\n .flex-row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: stretch;\n  align-items: center;\n}\n.search-placeholder {\n  min-height: 100px;\n  width: 364px;\n  flex: 1 0 auto;\n  align-self: stretch;\n}\n\n\n.generate-inventory-report-button {\n  min-width: 235px;\n  flex: 1 0 auto;\n  align-self: center;\n  //padding-left: 15px;\n  //padding-left: 40px;\n  //@error: -23px;\n  margin-top: 65px;\n  transform: translateY(-90px);\n   \n}\n\n @include respond-to (small) {\n\n  // .searchBox-label{\n  //   padding-bottom: 10px;\n  //   font: 1.6rem 'Omnes-ATT-W02-Medium';\n  //   margin: -90px 0px 0px 15px;\n  // }\n  .nav-links{\n    display: inline-flex;\n    flex-direction: column;\n  }\n  .flex-container-multiple-program {\n    @include vendor-prefix('flex-direction', column);\n  \n    border-right: 0;\n    flex-direction: column;\n    float: none;\n    width: 100%;\n    // border-bottom: 1px solid #d2d2d2;\n  }\n\n  .fieldset-extended {\n    margin: -135px 0px 0px 5px !important;\n    border: none;\n  }\n\n   margin: 0 15px;\n   margin-top: 70px;\n   .search {\n      position: absolute;\n      max-width: 275px; \n      transform: translateY(-117px); \n      margin-left: 20px; \n      padding-left: 10px;\n    }\n    .btn-report {\n        // background: linear-gradient(to bottom, #087ac2 0%, color(secondary,base) 100%);\n        background: linear-gradient(to bottom, #087ac2 0%, #0568ae 100%);\n        font-size: 17px;\n        height: 35px;\n        margin-left: -65px;\n        margin-bottom: 15px;\n        padding-right: 21px;\n        padding-left: 18px;\n        width: 263px;\n        // width: 82%;\n        transform: translateY(110px);\n    }\n    .search-placeholder {\n      min-height: 42px;\n     // width: 200px;\n    }\n    .generate-inventory-report-button {\n      min-width: 235px;\n      //padding-left: 9px;\n      //transform: translateY(5px);\n      margin: -10px 0px 20px 0px;\n    }\n\n    .navLinks{\n      float: left;\n      margin-left: 66px;\n      margin-top: 0px;\n     }\n\n    .oem-sms {\n      // width: 199px;\n      // margin-left: 62px;\n      //margin-left: -117px;\n\n      // figure {\n      //          //margin: 10px -76px;\n      //         margin: 3px -92px;\n      //         padding-left: 41px;\n      //         margin-left: -108px;\n      //         width: 173px;\n      //        }\n\n      img {\n        top: 934px;\n        left: 350px;\n        width: 49px;\n        height: 52px;\n      }\n      \n    }\n    [class^='col-md']{\n      width: 100%;\n    }\n     .new-content-ibm {\n     margin-right: 7px;\n     }\n\n   .report-button{\n    margin-right: 15px!important;\n    width: 280px;\n    margin-top: 55px;\n   }\n   .enrollDateInfo{\n    padding: 0;\n    margin: 0;\n    padding: 15px;\n   }\n   .greybox{\n    //max-height: 240px !important;\n    height: 490px;\n   }\n   .dropDownInput{\n    height: 80px !important;\n  }\n  .statusDropdown {\n    margin-top: -20px !important;\n  }\n  .search-btn {\n    margin-left: 0px !important;\n  }\n   .accordion {\n     margin-bottom: 30px;\n   }\n   \n   a {\n     cursor: pointer;\n   }\n   h1{\n     margin: 20px 0 20px;\n   }\n\n   #totalCount {\n     margin-top: 20px !important;\n     margin-left: 15px !important;\n   }\n\n   .page-count{\n      p.col-sm-12 {\n         margin-bottom: 0;\n         //margin-top: 20px !important;\n         text-align: left;\n         // padding-top:92px !important;\n         float:left;\n         \n       }\n   }\n   .error-alert {\n     margin-top: 20px;\n   }\n   .hr-line {\n   display: none;\n   }\n   \n   .alert {\n     margin-top: -60px;\n\n     div {\n       &:nth-child(2) {\n         padding-right: 30px;\n       }\n     }\n   }\n\n   .cancel-participation {\n     border-right: 0 solid color(default, dark);\n     display: block;\n   }\n\n   .download-terms {\n     padding-left: 0;\n   }\n\n   .nav-container-block {\n     @include vendor-prefix('transform', translateY(0%));\n     border: 0;\n     left: 0;\n     position: relative;\n     text-align: center;\n     top: 13px;\n     width: 100%;\n     margin-bottom: 15px;\n   }\n\n   .paginat1ion,\n   .toggle-header,\n   .panel-container {\n     margin-top: 20px;\n    \n   }\n\n   .panel-container {\n     margin-top: 20px;\n     margin-bottom: 20px;\n   }\n   .legend-container {\n     width: 100%;\n   }\n\n   .form-group,\n   .form-group~p,\n   .participation {\n     margin-bottom: 20px;\n   }\n   \n   .sub-header {\n     margin: 20px 0 5px 0;\n   }\n\n   .report-button{\n    margin-right: 15px!important;\n    width: 280px;\n    margin-top: 55px;\n\n   }\n\n   .nav-icon {\n     margin: 0;\n\n     li:nth-child(1) {\n       width: 50%;\n     }\n     \n     li:nth-child(2) {\n       width: 48%;\n     }\n     \n     li:nth-child(3) {\n       float: left;\n       width: 50%;\n     }\n   }\n\n   .cancel-participation,\n   .download-terms {\n     float: none;\n   }\n\n   .radio{\n    margin-bottom: 6px;\n   }\n\n   \n }\n}\n\n.lic-contest {\n @include respond-to (small) {\n   abbr,\n   label {\n     display: block;\n     margin: 0;\n   }\n }\n\n background-color: color(outOfCompliance);\n padding: 50px 0;\n\n .lic-container > div {\n   margin-bottom: 10px;\n }\n}\n.search-label{\n display: none;\n}\n\n.model-box{\n p{\n   font-weight: normal;\n   margin-top: 10px;\n }\n ol{\n       margin: 12px 0 10px 20px;\n        li {\n   list-style: decimal;\n    line-height: 20px;\n               margin-top: 12px;\n               padding-left: 15px;\n               position: relative;\n               text-align: left;\n }\n }\n ul{\n           margin: 12px 0 10px 20px;\n          //  li {\n          //    list-style-type: disc;\n          //    margin-left: 15px;\n          //     }\n           // li {\n           //     line-height: 20px;\n           //     margin-top: 12px;\n           //     padding-left: 15px;\n           //     position: relative;\n           //     text-align: left;\n           // }\n\n           // li::after{\n           //     background-color: #333333;\n           //     border: 2px solid #333333;\n           //     border-radius: 100%;\n           //     content: '';\n           //     display: block;\n           //     height: 1px;\n           //     left: 0;\n           //     position: absolute;\n           //     top: 8px;\n           //     width: 1px;\n           // }\n       }\n .tab-content{\n    left: 0;\n       padding:0 15px;\n\n }\n .startdate{\n   ul {\n     li {\n       list-style-type: disc;\n       margin-left: 15px;\n        }\n     }\n }\n .enrollPopup{\n  ul, li {\n      list-style: disc outside none;\n      margin-left: 15px;\n       }\n}\n\n}\n//Added for accessories\n.oem-accesories {\n  width: 150px;\n  //margin-left: 40px;\n  img {\n    top: 934px;\n    left: 350px;\n    width: 36px;\n    height: 52px; \n  }\n}\n.oem-accesories img {\n  top: 934px;\n  left: 350px;\n  width: 50px;\n  height: 50px;\n}\n","@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
